import React from "react";
import { Avatar } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import AppDropDown from "components/ui/AppDropdown";
import LangPicker from "components/lang-picker";
import AppIcon from "components/ui/AppIcon.jsx";
import { LogoutAction } from "redux/actions";
import { UTILS } from "utils";

const Navbar = ({ component }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const items = [
    {
      label: (
        <span className="flex items-center text-gray-600 gap-3 px-2 py-2">
          {t("My Profile")}
        </span>
      ),
      key: "profile",
    },
    {
      label: (
        <span className="flex items-center text-gray-600 gap-3 px-2 py-2">
          {t("Logout")}
        </span>
      ),
      key: "logout",
    },
  ];
  const logout = () => {
    // Notify other tabs about the logout
    localStorage.setItem("logoutEvent", Date.now().toString());
    localStorage.clear();
    UTILS.removeCurrentUser();
    UTILS.removeLanguageInformation();
    window.location.href = "/login";
    dispatch(LogoutAction.logout());
  };
  const currentUser = UTILS.getCurrentUser();
  const currentUserName =
    currentUser?.name ||
    currentUser?.fullName ||
    currentUser?.userName ||
    currentUser?.email?.split("@")?.[0] ||
    t("there");

  return (
    <div className="pt-6 pb-3"
      style={{ backgroundColor: "#F0F2F4", position: "sticky", top: 0, zIndex: 30, boxShadow: "0 2px 6px rgba(240, 242, 244, 0.6)" }}
    >
      <div
        className={`flex items-center bg-white flex-wrap gap-2 rounded-3xl p-4 px-8 py-4 justify-between shadow-primary-shadow`}
      >
        <div className="flex gap-2 items-center justify-start">
          {component ? component : null}
          <div className="text-24px font-semibold text-gray-900">
            {t("Hello")}, {currentUserName} <span role="img" aria-label="wave">👋</span>
          </div>
          {/* <PageBreadcrumbs breadCrumbs={pageBreadCrumb} /> */}
        </div>
        <div className="flex gap-2 items-center justify-end">
          <a
            href={`https://wa.me/${(process.env.REACT_APP_SUPPORT_MOBILE || "").replace(/[^0-9]/g, "")}?text=How can we help?`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 text-gray-700 hover:text-gray-800"
          >
            <AppIcon name="customerSupport" />
            <span className="text-sm font-medium">{t("Need Help?")}</span>
          </a>
          <div className="p-2">
            <LangPicker />
          </div>

          <Avatar size="large" />
          <AppDropDown
            dropdownMenu={items}
            onItemClick={(key) => key === "logout" && logout()}
            icon="arrowDown"
          />
        </div>
      </div>
    </div>
  );
};

export default Navbar;
